export const ERROR_EIGHTY_SIXTH = {
  banner: 'eighty-six-error-banner',
  unavailableItem: 'eighty-six-unavailable-item-text',
  unavailableModifier: 'eighty-six-unavailable-modifier-text',
};
